import Carousel from "react-bootstrap/Carousel";
import like1 from "./image/like1.png";
import like2 from "./image/like2.png";
import like3 from "./image/like3.png";
import like4 from "./image/like4.png"; 
import like5 from "./image/like5.png";
import like6 from "./image/image6.png";
import like7 from "./image/like7.png";
import like8 from "./image/myslidpic1.png";

function Slider() {
  return (
    <Carousel className="slide-in-left" >
      <Carousel.Item  style={{transition:"0.4s all"}} >
        <img
          id="setimg"
          className="d-block w-100"
          src={like1}
          alt="First slide"
        />
        <Carousel.Caption>
          <h3>AI Animation </h3>
          <p></p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like8} alt="Second slide" />

        <Carousel.Caption>
          <h3>Company Logo-sheet</h3>
          <p></p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like2} alt="Third slide" />

        <Carousel.Caption>
          <h3>Data Recovering Area</h3>
          <p>
          
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like3} alt="Third slide" />

        <Carousel.Caption>
          <h3>Hacking platform</h3>
          <p>
          </p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like4} alt="Third slide" />

        <Carousel.Caption>
          <h3>A new Generation</h3>
          <p>
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like5} alt="Third slide" />

        <Carousel.Caption>
          <h3>Dark side</h3>
          <p>
          
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like6} alt="Third slide" />

        <Carousel.Caption>
          <h3>Design setup</h3>
          <p>
          
          </p>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item style={{transition:"0.4s all"}}>
        <img className="d-block w-100" src={like7} alt="Third slide" />

        <Carousel.Caption>
          <h3>My office</h3>
          <p>
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Slider;
